/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
  // Add custom code below this line

  // Select the target node (the element to observe)
  const desktopCartCounter = document.getElementById('desktop_cart_counter');
  const mobCartCounter = document.getElementById('mob_cart_counter');

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
              // Update mob_cart_counter text to match desktop_cart_counter
              mobCartCounter.textContent = desktopCartCounter.textContent;
          }
      }
  });

  // Configuration of the observer:
  const config = { childList: true, characterData: true, subtree: true };

  // Start observing the target node for configured mutations
  observer.observe(desktopCartCounter, config);

  // Debugging: Log changes to observe if the mutation is being detected
  desktopCartCounter.addEventListener('DOMSubtreeModified', () => {
      console.log('desktop_cart_counter modified:', desktopCartCounter.textContent);
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.


document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll(".col-tab-link");
  const tabContents = document.querySelectorAll(".tab-collection");

  tabLinks.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault();

      tabLinks.forEach(function(link) {
        link.classList.add("as-col-nav");
        link.classList.remove("as-underline");
        link.classList.add("as-text-[#9F9F9F]");
        link.classList.remove("as-text-[#000]");
      });

      this.classList.remove("as-col-nav");
      this.classList.add("as-underline");
      this.classList.remove("as-text-[#9F9F9F]");
      this.classList.add("as-text-[#000]");

      const targetId = this.getAttribute("data-target");
      if (!targetId) return; // If no data-target attribute, exit

      tabContents.forEach(function(tabContent) {
        tabContent.classList.add("as-hidden");
      });

      const targetTab = document.getElementById(targetId);
      if (targetTab) {
        targetTab.classList.remove("as-hidden");
      }
    });
  });
});

document.addEventListener('click', function(event) {
  // Check if the clicked element matches '.select-popout__option'
  if (event.target.closest('.select-popout__option')) {
      // Find the span[data-qty-text] within the clicked element
      const qtyTextElement = event.target.closest('.select-popout__option').querySelector('span[data-qty-text]');
      const qtyText = qtyTextElement ? qtyTextElement.textContent : '';

      // Set the text of the '#qty-text' element
      const targetElement = document.querySelector('#qty-text');
      if (targetElement) {
          targetElement.textContent = qtyText;
      }
  }
});


/* =========================================================================
   Flavour selector fix (merged CGB PDP)  — v4
   -------------------------------------------------------------------------
   Admin tags such as "[Pre-Order] " were added to a Flavour option value
   (e.g. "[Pre-Order] Strawberry Smoothie"). Three PDP systems key off the
   flavour string:
     * subscription cards  -> rendered with the REAL value  {{ v.option2 }}
     * flavour selector    -> was hardcoded to the base name
     * left image gallery  -> matches media by the base flavour name

   data-flavor MATCHING is normalised to the base name (tag stripped) on both
   the buttons and the cards, so subscriptions + gallery both work. The REAL
   variant is untouched, so cart/checkout/orders still show "[Pre-Order]".
   The original full value is preserved in data-flavor-full so this routine is
   idempotent (safe to run more than once).

   The visible .sl-name label is cosmetic (nothing keys off it), so it shows
   the FULL, dynamic variant value pulled from the product
   (e.g. "[Pre-Order] Strawberry Smoothie") — except Sugar-Free, which keeps
   its custom "Zero" label. Safe no-op on any page without the selector.
   ========================================================================= */
(function () {
  function canon(s) {
    s = (s || '').trim();
    s = s.replace(/^\s*\[[^\]]*\]\s*/, ''); // drop a leading "[...]" tag
    return s.trim();
  }
  function isZero(s) {
    s = (s || '').toLowerCase();
    return s.indexOf('sugar') > -1 || s.indexOf('zero') > -1;
  }

  function fixFlavourSelector() {
    try {
      var wrap = document.querySelector('.sl-wrap');
      if (!wrap) return;

      // Build base-name -> full-variant-value map from the subscription cards.
      // Preserve each card's ORIGINAL full value in data-flavor-full so repeat
      // runs don't lose it after data-flavor has been normalised.
      var fullByBase = {};
      document.querySelectorAll('.lw-card[data-flavor], .lw-onetime [data-flavor]').forEach(function (el) {
        if (!el.hasAttribute('data-flavor-full')) {
          el.setAttribute('data-flavor-full', el.getAttribute('data-flavor'));
        }
        var full = el.getAttribute('data-flavor-full');
        var c = canon(full);
        if (c && !(c in fullByBase)) fullByBase[c] = full;
        if (c && el.getAttribute('data-flavor') !== c) el.setAttribute('data-flavor', c);
      });

      // Normalise selector buttons for matching (untagged names stay the same,
      // so the gallery keeps working), and label from the real variant value.
      wrap.querySelectorAll('.sl-option').forEach(function (btn) {
        if (!btn.hasAttribute('data-flavor-full')) {
          btn.setAttribute('data-flavor-full', btn.getAttribute('data-flavor') || '');
        }
        var c = canon(btn.getAttribute('data-flavor-full'));
        if (c && btn.getAttribute('data-flavor') !== c) btn.setAttribute('data-flavor', c);

        var nameEl = btn.querySelector('.sl-name');
        if (nameEl) {
          var label = isZero(c) ? 'Zero' : (fullByBase[c] || canon(btn.getAttribute('data-flavor-full')) || c);
          nameEl.textContent = label;
          var img = btn.querySelector('img');
          if (img) img.setAttribute('alt', label);
        }
      });
    } catch (e) {
      if (window.console) console.warn('flavour selector fix skipped:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFlavourSelector);
  } else {
    fixFlavourSelector();
  }
  setTimeout(fixFlavourSelector, 1500);
})();
